export function isExpired(expiresAt: string | null | undefined): boolean {
    if (!expiresAt) return false; // Not expired if no expiration date set
    return new Date(expiresAt) < new Date();
}

export function isExpiringSoon(expiresAt: string | null | undefined, hoursThreshold: number = 24): boolean {
    if (!expiresAt) return false; // Not expiring soon if no expiration date set
    const expires = new Date(expiresAt);
    const now = new Date();
    const hoursUntilExpiry = (expires.getTime() - now.getTime()) / (1000 * 60 * 60);
    return hoursUntilExpiry < hoursThreshold && hoursUntilExpiry > 0;
}

export function getHoursUntilExpiry(expiresAt: string | null | undefined): number {
    if (!expiresAt) return 0; // Return 0 if no expiration date set
    const expires = new Date(expiresAt);
    const now = new Date();
    return Math.ceil((expires.getTime() - now.getTime()) / (1000 * 60 * 60));
}

export async function copyToClipboard(text: string): Promise<void> {
    try {
        await navigator.clipboard.writeText(text);
    } catch (error) {
        console.error('Failed to copy to clipboard:', error);
        throw error;
    }
}

